import React from "react";
import { Row, Col, Space, Image, Collapse, Tooltip,Spin } from "antd";
import dayjs from "dayjs";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import CompanyAutocomplete from "./CompanyAutocomplete";
import ListTable from "./ListTable";
import TrackByGroupStore from "../store/TrackByGroupStore";
import { Link } from "react-router-dom";
import MapForVehiclePosition from "./MapForVehiclePosition";
import withRouter from "../withRouter";
import utc from "dayjs/plugin/utc";

const { Panel } = Collapse;

dayjs.extend(utc);
class TrackByGroup extends React.Component {
  constructor(props) {
    super(props);
    this.TrackByGroupStore = new TrackByGroupStore(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
   this.handleTableChange = this.handleTableChange.bind(this);
    this.state = {
      companyId: "",
      loading: false,
      loadData: 0,
      pageSize: 50,
      offset: 0,
      limit: 50,
      pageNo: 1,
      vehicleObj: false,
      show: false,
      id: "",
      loading: false,
      currentPage: 1
    };
  }

  // Assuming 'data' is part of the component's state or class property

  async componentDidMount() {
    if (Number(this.props.getUserData().isadmin) !== -1) {
      await this.setState({
        companyId: this.props.getUserData().userCompanyId,
      });
      await this.setState({ userId: this.props.getUserData().userId });
      await this.handleSearch();
    }
    this.columns = [
      {
        // title: "Company",
        title: this.context.translate("_FLEET_DASHBORD_NEWPOI_COMPANY_"),
        dataIndex: "companyName",
        width: 18,
        key: "companyName",
        ellipsis: {
          showTitle: true,
        },
        render: (companyName) => (
          <Tooltip placement="topLeft" title={companyName}>
            {companyName}
          </Tooltip>
        ),
      },
      {
        // title: "Vehicle No",
        title: this.context.translate("_VEHICLE_NO_"),
        dataIndex: "vehicleNo",
        width: 18,
        key: "vehicleNo",
        ellipsis: {
          showTitle: true,
        },

        render: (_, record) => {
          return (
            <Space>
              <Tooltip placement="topLeft" title={record.vehicleNo}>
                <Image
                  width={30}
                  height={15}
                  src={require("../assets/images/detailtracking/" +
                    record.listImage)}
                />

                {record.vehicleNo}
              </Tooltip>
            </Space>
          );
        },
      },
      {
        // title: "Type",
        title: this.context.translate("_FLEET_DASHBORD_NEWPOI_TYPE_"),
        dataIndex: "vehicleTypeNew",
        width: 6,
        key: "vehicleTypeNew",
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: "Driver",
        title: this.context.translate(
          "_FLEET_DASHBORD_HISTORY_TOOLTIP_DRIVER_"
        ),
        dataIndex: "name",
        width: 12,
        key: "name",
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: "Location",
        title: this.context.translate(
          "_FLEET_DASHBORD_HISTORY_TOOLTIP_LOCATION_"
        ),
        dataIndex: "formatted_address",
        width: 20,
        key: "formatted_address",
        ellipsis: {
          showTitle: true,
        },
        render: (value, obj) => {
          return (
            <Link
              style={{ color: "#2563EB", textDecoration: "none" }}
              onClick={async (e) => {
                // await this.setState({ showMap: true, modalInfoObj: obj });
                await this.setState({
                  vehicleObj: { ...obj, icon: "logo_icon.png" },
                  heading: "Location On Map",
                });
                await this.setState({ loadData: 1 });
              }}
            >
              {value}
            </Link>
          );
        },
      },
      {
        // title: "Ignition",
        title: this.context.translate("_IGNITION_"),
        dataIndex: "acc",
        width: 10,
        key: "acc",
        ellipsis: {
          showTitle: true,
        },
        render: (value) => {
          if (value == 1) {
            var img = "ignition-icon-on.png";
          } else {
            var img = "ignition-icon-off-red.png";
          }
          return (
            <>
              <Image
                src={require("../assets/images/detailtracking/" + img)}
                width={20}
                height={20}
              />
            </>
          );
        },
      },
      {
        // title: "Speed (km)",
        title: this.context.translate("_SPEED_KM_"),
        dataIndex: "speed",
        width: 8,
        key: "Speed",
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: "Time",
        title: this.context.translate("_FLEET_DASHBORD_RULETRIGGER_TIME_"),
        dataIndex: "updatedate",
        width: 14,
        key: "updatedate",
        ellipsis: {
          showTitle: true,
        },
        render: (value) => {
          const formattedDateTime = dayjs
            .utc(value)
            .format("DD-MM-YYYY hh:mm:ss A");
          return <>{formattedDateTime}</>;
        },
      },
      {
        // title: "GPS",
        title: this.context.translate("_GPS_"),
        dataIndex: "GPS",
        width: 6,
        key: "GPS",
        ellipsis: {
          showTitle: true,
        },
        render: (value) => {
          return (
            <>
              <Image
                src={require("../assets/images/detailtracking/gps-icon-on-green.png")}
                width={20}
                height={20}
              />
            </>
          );
        },
      },
      {
        // title: "Alert",
        title: this.context.translate("_FLEET_ALERT_"),
        dataIndex: "alert",
        width: 6,
        key: "alert",
        ellipsis: {
          showTitle: true,
        },
        render: (value) => {
          if (value == 0) {
            var img = "alert-icon-green.png";
          } else {
            var img = "alert-icon-red.png";
          }
          return (
            <>
              <Image
                src={require("../assets/images/detailtracking/" + img)}
                width={20}
                height={20}
              />
            </>
          );
        },
      },
      {
        // title: "Odometer",
        title: this.context.translate("_FLEET_DASHBORD_SETTING_ODOMETER_"),
        dataIndex: "distance",
        width: 10,
        key: "distance",
        ellipsis: {
          showTitle: true,
        },
      },
    ];
    await this.setState({ loadList: 1 });
  }

  async componentDidUpdate(prevProps, prevState) {
    if (this.state.vehicleObj !== prevState.vehicleObj) {
      console.log("ilocasd");
      setTimeout(() => {
        window.dispatchEvent(new Event("resize"));
      });
    }
  }
  async handleChange(comp) {
    this.TrackByGroupStore.newGroupdata = [];
    await this.setState({
      companyId: comp.value,
    });

    await this.handleSearch();
    await this.setState({ update: 1 });
    // console.log("data", data);
  }

  async handleSearch() {
    this.setState({ loading: true });
    await this.TrackByGroupStore.loadData({
      companyId: this.state.companyId,

    });
    await this.setState({ loading: false, loadData: 1 });
  }

  async handleTableChange(pagination, filters, sorter) {
    const { selectedGroupId, pageSize, companyId } = this.state;

    if (!selectedGroupId) return;
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    //await this.handleSearch();

    await this.TrackByGroupStore.trackgroupdata({
      deviceGroupId: selectedGroupId,
      companyId,
      offset: (pagination.current - 1) * pagination.pageSize,
      limit: pagination.pageSize,
    });

     this.setState({ loading: false });
  }

  onChange = async (key) => {

    this.setState({ selectedGroupId:  key[0] });

    const group = this.TrackByGroupStore.Trackbygroupdata.find(
      g => g.deviceGroupId == key[0]
    );

    if (!group || group.vehicleCount == 0) {
      this.TrackByGroupStore.newGroupdata.length = 0;
       this.TrackByGroupStore.totalcount = 0;
      return;
    }

    this.setState({ loading: true,selectedGroupId: key[0] });
    await this.TrackByGroupStore.trackgroupdata({
      deviceGroupId: key[0],
      companyId: this.state.companyId,
      offset: (this.state.currentPage - 1) * this.state.pageSize,
      limit: this.state.pageSize,
    });
    await this.setState({ loading: false, loadData: 1 });
  };
  render() {
    return (
      <>
        <div className="dashboardHeader">
          <Row className="listInputRow">
            <Col span={20}>
              <Space>
                <CompanyAutocomplete
                  className="searchInput"
                  allowClear={true}
                  onChange={this.handleChange}
                  style={{ width: 200 }}
                />
              </Space>
            </Col>
          </Row>

          <Row>
            <div style={{ width: "100%", borderWidth: 0 }}>
              <div className="pageTitle">
                {" "}
                {this.context.translate("_GROUP_NAME_")}
              </div>

              <Collapse
                size="small"
                accordion
                items={this.TrackByGroupStore?.Trackbygroupdata?.map(
                  (item) => ({
                    key: item.deviceGroupId,
                    label: (
                      <div>
                        {item.groupname} ({item.vehicleCount})
                      </div>
                    ),

                    children: (
                      <div key={this.state.selectedGroupId}>
                        {item.vehicleCount === 0 ? (
                          <div style={{ padding: 16, textAlign: "center", color: "#999" }}>
                            No vehicles found
                          </div>
                        ) : (
                      <Spin spinning={this.TrackByGroupStore?.loading}>
                      <ListTable
                        pagination={true}
                        currentPage={this.state.currentPage}
                        pageSize={this.state.pageSize}
                        columns={this.columns}
                         total={this.TrackByGroupStore?.totalcount}
                        //loading={this.TrackByGroupStore?.loading}
                        dataSource={this.TrackByGroupStore?.newGroupdata}
                        deviceGroupId={item.deviceGroupId}
                        onChange={this.handleTableChange}
                      />
                      </Spin>
                       )}
                    </div>
                    ),
                  })
                )}
                onChange={this.onChange}
                className="collapse-panel"
              />
            </div>
          </Row>

          {this.state.vehicleObj && (
            <MapForVehiclePosition
              vehicleObj={this.state.vehicleObj}
              heading={this.state.heading}
              closeMapModal={(resp) => {
                this.setState({ vehicleObj: resp });
              }}
            />
          )}
        </div>
      </>
    );
  }
}

TrackByGroup.contextType = StoreContext;
export default observer(withRouter(TrackByGroup));
